import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  marqueeWrapper: {
    overflow: "hidden",
    maxWidth: "100%",
  },
  marqueeText: {
    display: "inline-block",
    whiteSpace: "nowrap",
  },
  truncatedText: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const MARQUEE_SCROLL_DURATION_MS = 6000;
const MARQUEE_PAUSE_DURATION_MS = 1000;
const MARQUEE_RETURN_DURATION_MS = 220;
const MARQUEE_LOOP_COUNT = 2;

export default function CampusNameDisplay({ name }) {
  const classes = useStyles();
  const spanRef = useRef(null);
  const wrapperRef = useRef(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    setDone(false);
  }, [name]);

  useEffect(() => {
    if (done) return;
    const span = spanRef.current;
    const wrapper = wrapperRef.current;
    if (!span || !wrapper) return;

    // スクロール距離を計算
    const scrollPx = Math.max(0, span.scrollWidth - wrapper.clientWidth);

    // スクロール距離が0の場合はアニメーション不要なので完了状態にする
    if (scrollPx === 0) {
      setDone(true);
      return;
    }

    let cancelled = false;

    async function runAnimation() {
      try {
        for (let i = 0; i < MARQUEE_LOOP_COUNT; i++) {
          if (cancelled) return;

          // 末尾へ移動
          await span.animate(
            [{ transform: "translateX(0px)" }, { transform: `translateX(-${scrollPx}px)` }],
            { duration: MARQUEE_SCROLL_DURATION_MS, easing: "ease-in-out", fill: "forwards" }
          ).finished;
          if (cancelled) return;

          // 末尾で静止
          await new Promise((resolve) => setTimeout(resolve, MARQUEE_PAUSE_DURATION_MS));
          if (cancelled) return;

          // 先頭へ移動
          await span.animate(
            [{ transform: `translateX(-${scrollPx}px)` }, { transform: "translateX(0px)" }],
            { duration: MARQUEE_RETURN_DURATION_MS, easing: "ease-in", fill: "forwards" }
          ).finished;
        }
        if (!cancelled) setDone(true);
      } catch {
        // アニメーションがキャンセルされた場合などにエラーが発生することがあるが、無視して終了する
      }
    }

    runAnimation();
    return () => {
      cancelled = true;
      span.getAnimations().forEach((a) => a.cancel());
    };
  }, [name, done]);

  if (done) {
    return (
      <div className={classes.marqueeWrapper}>
        <span className={classes.truncatedText}>{name}</span>
      </div>
    );
  }

  return (
    <div ref={wrapperRef} className={classes.marqueeWrapper}>
      <span ref={spanRef} className={classes.marqueeText}>
        {name}
      </span>
    </div>
  );
}
